export const ClosingDocumentsSectionTestIds = {
  OPEN_NEW_TAB_BUTTON: 'closing-documents.open-new-tab-button',
  AMORTIZATION_BUTTON: 'closing-documents.amortization-button',

  getDocumentLinkId: index => `closing-documents.document-link-${index}`,
};
